// Canonical entity type strings. UI filter chips, Convex query handlers,
// migrations, and tests ALL import from here so a rename in one place
// ripples through the entire codebase. See spec §3 + Spec 4 plan Task 1.
export const ENTITY_TYPES = Object.freeze([
  "security-note",
  "policy-decision",
  "dlp-hit",
  "approval-resolved",
  "pr-risk-brief",
] as const);

export type EntityType = (typeof ENTITY_TYPES)[number];

export function isValidEntityType(value: unknown): value is EntityType {
  return typeof value === "string" && (ENTITY_TYPES as ReadonlyArray<string>).includes(value);
}
